export default "__VITE_ASSET__db253827__"